import { TextsType } from '../types'
const sections = [
  { url: 'domu', name: 'Home' },
  { url: 'projekty', name: 'Projects' },
  { url: 'cv', name: 'CV' },
]
const texts: TextsType = {
  title: 'Jakub Sirotek',
  sections: sections,
  name: 'Jakub Sirotek',
  switcher: ['Web', 'Interests'],
  introduction: [
    'Jakub Sirotek',
    <>
      I am a <span>front-end developer</span> and <span>designer</span>. I build
      modern web applications primarily using <span>React</span>,{' '}
      <span>TypeScript</span>, and <span>Next.js</span>. Thanks to my background
      in graphics and design, I focus not only on high-quality code but also on
      aesthetics, interaction, and user experience.
    </>,
    <>
      I have been working with <span>React</span> since 2022, and in 2026, I
      expanded my expertise to include <span>Next.js</span>. I primarily use{' '}
      <span>Cursor</span> as a supplement to <span>ChatGPT</span>. I also have
      experience with <span>Tailwind CSS</span>, <span>styled-components</span>,{' '}
      <span>Prisma</span>, <span>PostgreSQL</span>, and <span>Vercel</span>, and
      I am gradually shifting my focus toward full-stack development.
    </>,
    'I previously used primarily vanilla JavaScript and various JS libraries as needed. In terms of graphics, I also worked with 3D graphics and animations.',
    'I enjoy working in a team and learning new things and deepening existing skills.',
  ],
  skills: ['Front-end', 'Design', '3D, post effects', 'Learning'],
  otherprojects: 'Older projects',
  contacts: {
    title: 'Contacts',
    email: ['email:', 'sirotek.j@gmail.com'],
    linkedin: [
      'LinkedIn:',
      'https://www.linkedin.com/in/jakub-sirotek-1bb0364a/',
    ],
  },
  eriwen: {
    name: 'Eriwen',
    link: 'https://www.eriwen.cz/',
    type: 'web site',
    year: '2026',
    technics: [
      'NextJS',
      'typescript',
      'tailwind',
      'github',
      'vercel',
      'prisma',
    ],
    aspectRatio: '16/9',
    preview: 'images/web/eriwen/eriwenpreview.jpg',
    imgs: [
      'images/web/eriwen/eriwen1.jpg',
      'images/web/eriwen/eriwen2.jpg',
      'images/web/eriwen/eriwen3.jpg',
      'images/web/eriwen/eriwen4.jpg',
    ],
    intro:
      'A site for a group of friends playing "Dračí doupě" to share information—characters, stories, maps, environments, etc.',
    texts: [
      <>
        <p>
          For this project, I chose a stack that was new to me, using{' '}
          <span>Next.js</span> and <span>TypeScript</span>. I chose this
          approach partly because I was going through a Next.js course, which
          made the learning process both more intensive and more creative. At
          the same time, using ChatGPT made the work faster and provided greater
          clarity in unfamiliar territory.
        </p>
        <p>
          The entire codebase is on <span>GitHub</span> and is built on{' '}
          <span>Vercel</span>.
        </p>
      </>,
      <>
        For authentication, I chose <span>NextAuth</span>, allowing each member
        to log in using their email account.
      </>,
      <>
        <p>
          The Neon database runs on Vercel, which also hosts the blob storage
          for images. In Next.js, I use the newer Server Actions and Prisma. I
          used also Jodit Rich Textt Editor in forms.
        </p>
        <p>
          I also handled various methods of data sorting within the database to
          accommodate different types of posts. These ranged from sorting by an
          order value—including inserting items between existing ones—and
          hierarchical location sorting, to a specialized calendar system that
          supports entries based on years, specific dates, months, or seasons.
        </p>
      </>,
    ],
  },
  voicesofthebrave: {
    name: 'Voices of the Brave',
    link: 'https://www.currenttime.tv/a/voices-of-the-brave/33441095.html',
    type: 'microsite',
    year: '2025',
    technics: ['React', 'datawrapper', 'swiper'],
    aspectRatio: '8/5',
    preview: 'images/web/voicesofthebrave/voicesofthebravepreview.jpg',
    imgs: [
      'videos/web/voicesofthebrave/voicesofthebraveVideo1.mp4',
      'images/web/voicesofthebrave/voicesofthebrave2.jpg',
      'images/web/voicesofthebrave/voicesofthebrave3.jpg',
      'videos/web/voicesofthebrave/voicesofthebravevideo2.mp4',
    ],
    intro:
      'A microsite focused on domestic violence. It consists of five chapters, each telling a personal story. The project is based on original illustrations used in various ways across the chapters.',
    texts: [
      'Each chapter begins with an animation created from an original illustration. Positioning animated elements across different layouts and screen resolutions was particularly challenging.',
      'The site also includes illustration fragments with a parallax effect.',
      <>
        For several charts and maps, we chose <span>datawrapper</span> for its
        simplicity and because it allowed editors to update the content
        themselves.
      </>,
      'An example of one of the six main animations that introduce each chapter.',
      'I enjoy working in a team, learning new things or deepening existing skills.',
    ],
  },
  soldierswhodiedinukraine: {
    name: 'Soldiers Who Died in Ukraine',
    type: 'Microsite',
    year: '2022',
    link: 'https://www.azatliq.org/a/sugishta-ulucheler/31916561.html',
    technics: ['React', 'react-router-dom', 'framer-motion'],
    aspectRatio: '8/5',
    preview:
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukrainepreview.jpg',
    imgs: [
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine1.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine2.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine3.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine4.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine5.jpg',
    ],
    intro:
      'A page dedicated to victims of the war in Ukraine from Tatarstan and Bashkortostan.',
    texts: [
      <>
        An infographic built in <span>React</span>. The opening screen features
        a carousel with selected photographs and basic information about the
        project.
      </>,
      <>
        The next section presents a map with two selectable regions. Data is
        loaded from a Google Drive document via an API, and individual areas are
        color-coded based on the numbers.
      </>,
      'The main section contains lists of fallen soldiers. To avoid excessive scrolling, pagination was used instead of lazy loading.',
      <>
        Advanced multi-level filters were implemented due to the large number of
        entries. Users can filter by region, age, rank, and more.
      </>,
      'Each individual has a dedicated page with a unique ID that can be shared separately. Additional filtered lists appear below the profile card.',
    ],
  },
  ukraineweapons: {
    name: 'Ukrainian Weapons',
    link: 'https://www.svoboda.org/a/legendarnoe-oruzhie-ukrainy/32284978.html',
    technics: ['Svelte', 'swiper', 'gsap'],
    type: 'microsite',
    year: '2023-2024',
    aspectRatio: '128/73',
    preview: 'images/web/ukraineweapons/ukraineweaponspreview.jpg',
    imgs: [
      'images/web/ukraineweapons/ukraineweapons1.jpg',
      'videos/web/ukraineweapons/ukraineweaponsvideo.mp4',
      'images/web/ukraineweapons/ukraineweapons3.jpg',
      'images/web/ukraineweapons/ukraineweapons4.jpg',
      'images/web/ukraineweapons/ukraineweapons5.jpg',
      'images/web/ukraineweapons/ukraineweapons6.jpg',
    ],
    intro:
      'A project built with the Svelte framework, focusing on the use of selected modern weapons in the war in Ukraine. My responsibility was functionality and code implementation.',
    texts: [
      'This was a long-term project divided into four chapters, released gradually between 2023 and 2024.',
      'The core of each chapter is a weapon presentation where animations are controlled by scrolling and pause at specific moments to display descriptions.',
      'Responsiveness was one of the main challenges due to animations and annotated videos. More significant layout differences were required for mobile devices.',
      'The project contains a large number of interactive elements.',
      'Animations were often triggered by scrolling or directly linked to scroll position.',
      <>
        The project also served as a test of the <span>Svelte</span> framework
        to help the team decide whether to continue using it or return to React.
      </>,
    ],
  },
  ctcatalogue: {
    name: 'Current Time Catalog',
    type: 'microsite',
    year: '2022',
    link: 'https://www.currenttime.tv/a/28791461.html',
    technics: ['React', 'react-router-dom', 'framer-motion', 'swiper'],
    aspectRatio: '8/5',
    preview: 'images/web/ctcatalogue/ctcataloguepreview.jpg',
    imgs: [
      'videos/web/ctcatalogue/ctcatalogueVideo2.mp4',
      'videos/web/ctcatalogue/ctcatalogueVideo1.mp4',
      'images/web/ctcatalogue/ctcatalogue.jpg',
    ],
    intro: (
      <>
        CT Catalog is a website presenting descriptions of dozens of selected
        programs on Current Time TV. My role was to build a fully functional
        page in <span>React</span> based on the provided design.
      </>
    ),
    texts: [
      <>
        This was the first project I built entirely in <span>React</span>. The
        site consists of a program overview divided into multiple categories,
        requiring dynamic layout adjustments based on filtering.
      </>,
      'A tile-based layout allowed for an effective and flexible design on smaller devices.',
      <>
        <span>react-router-dom</span> was used for in-site navigation,
        <span>framer motion</span> for animations, and <span>swiper</span> for
        simple navigation between program details.
      </>,
    ],
  },
  web: [
    {
      name: 'Timeline Ukraine War',
      type: 'Microsite',
      year: '2025',
      technics: ['React'],
      aspectRatio: '16/9',
      preview: 'images/web/timelineukrainewar/timelineukrainewar1_m.jpg',
      imgs: [
        'images/web/timelineukrainewar/timelineukrainewar1.jpg',
        'images/web/timelineukrainewar/timelineukrainewar2.jpg',
        'images/web/timelineukrainewar/timelineukrainewar3.jpg',
      ],
      link: 'https://www.radiosvoboda.org/a/istoriya-viyny-rosiya-ukraina/32831284.html',
      intro: (
        <>
          Timeline with most important events in last 10 years. Graphics is
          created in <span>Reactu</span>.
        </>
      ),
      texts: [],
    },
    {
      name: 'Srebrenica Anniversary',
      type: 'Microsite',
      year: '2022',
      technics: ['HTML', 'CSS', 'JavaScript'],
      aspectRatio: '16/9',
      preview: 'images/web/srebrenicaanniversary/srebrenicaanniversary1_m.jpg',
      imgs: [
        'images/web/srebrenicaanniversary/srebrenicaanniversary2.jpg',
        'videos/web/srebrenicaanniversary/srebrenicaanniversaryvideo1.mp4',
        'images/web/srebrenicaanniversary/srebrenicaanniversary3.jpg',
      ],
      link: 'https://www.slobodnaevropa.org/a/srebrenica-dokumentovani-genocid/30713005.html',
      intro:
        'An infographic created for the anniversary of the Srebrenica genocide. Due to the relatively simple interaction model, I chose to use vanilla JavaScript only.',
      texts: [
        'Together with the project designer, we collaborated on a unique interaction system using a rotating flower as both the menu and pagination.',
        'Ensuring a well-structured layout across different devices was essential. This was handled partly with CSS and partly with JavaScript.',
      ],
    },
    {
      name: 'Constitution is difficult in Kazakh',
      type: 'Microsite',
      year: '2022',
      technics: ['HTML', 'css', 'JavaScript', 'swiper'],
      aspectRatio: '16/9',
      preview: 'images/web/kazakhconstitution/kazakhconstitution1_m.jpg',
      imgs: [
        'images/web/kazakhconstitution/kazakhconstitution1.jpg',
        'images/web/kazakhconstitution/kazakhconstitution2.jpg',
      ],
      link: 'https://www.idelreal.org/a/31569821.html',
      intro: 'Graphic about issues with the Kazakh constitution.',
      texts: [
        <>
          Whole graphics are created in vanilla js using one js library:{' '}
          <span>swiper</span>.
        </>,
      ],
    },
    /*{
      name: 'Chamber 319',
      type: 'Microsite',
      year: '2021',
      technics: ['HTML', 'css', 'JavaScript', 'grunt'],
      aspectRatio: '16/9',
      preview: 'images/Chamber.png',
      imgs: ['images/Chamber.png'],
      link: 'https://www.idelreal.org/a/31569821.html',
      intro: (
        <>
          Grafika o násilí při vyslýchání ve vězení v Tatarstánu. Microsite byla
          vytvořena za pomoci <span>Grunt</span> task runner na minifikaci
          javascriptu a sass.
        </>
      ),
      texts: [],
    },*/
    {
      name: 'US Election 2020',
      type: 'Graphics',
      year: '2020',
      technics: ['HTML', 'javascript', 'css', 'underscore'],
      aspectRatio: '16/9',
      link: 'https://www.currenttime.tv/a/elections-us-2020/30926082.html',
      preview: 'images/web/uselections/uselectionspreview.jpg',
      imgs: [
        'images/web/uselections/uselections1.jpg',
        'images/web/uselections/uselections2.jpg',
      ],
      intro:
        'An infographic presenting the results of the 2020 U.S. presidential election.',
      texts: [
        'The page was published in more than ten languages. A Google Sheet was used to allow editors to enter the required translations.',
        <>
          The content was loaded from a Google spreadsheet prepared for editors.
          Using the <span>underscore</span> JavaScript library, individual
          sections were dynamically rendered based on the data.
        </>,
      ],
    },
    {
      name: 'The Tragedy of the Kursk',
      type: 'Microsite',
      year: '2015',
      technics: ['HTML', 'CSS', 'JavaScript'],
      aspectRatio: '16/9',
      link: 'https://www.rferl.org/a/kursk-russia-submarine-disaster/27183289.html',
      preview: 'images/web/kursk/kursk1_s.jpg',
      imgs: [
        'images/web/kursk/kursk1.jpg',
        'images/web/kursk/kursk2.jpg',
        'images/web/kursk/kursk6.jpg',
        'images/web/kursk/kursk5.jpg',
      ],
      intro:
        'An infographic commemorating the anniversary of the sinking of the Kursk submarine.',
      texts: [
        'I worked as part of a team with a 3D artist. The core of the project consisted of animations created as frame sequences animated using JavaScript.',
        'The animations paused at specific points where explanatory labels were displayed.',
        'For mobile devices, due to the wide-screen design, we replaced animations and interactivity with static images and labels. The graphic was prepared in multiple languages.',
      ],
    },
  ],
  others: [
    {
      name: 'STEP',
      type: 'flash',
      preview: 'images/3d/step/stepvodikovaekonomika_s.jpg',
      imgs: [
        'images/3d/step/stepvodikovaEkonomika.jpg',
        'images/3d/step/steptechnologiepiva.jpg',
        'images/3d/step/stepperiodickatabulka.jpg',
        'images/3d/step/stepchemickyrobot.jpg',
        'images/3d/step/stepcisteniodpadnichvod.jpg',
        'images/3d/step/stepfotokatalyza.jpg',
      ],
      year: '2013 - 2014',
      link: 'https://step.vscht.cz/infografiky/vodikova-ekonomika/',
      technics: ['Flash', 'Cinema 4D'],
      aspectRatio: '16/9',
      intro:
        'Visualization of selected topics for the University of Technology.',
      texts: [
        <a
          href="https://step.vscht.cz/infografiky/vodikova-ekonomika/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/vodikova-ekonomika/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/vyroba-piva/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/vyroba-piva/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/periodicka-tabulka-prvku/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/periodicka-tabulka-prvku/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/chemicky-robot/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/chemicky-robot/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/odpadni-vody/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/odpadni-vody/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/fotokatalyza/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/fotokatalyza/
        </a>,
      ],
    },
    {
      name: 'A world of discoveries',
      type: 'Advertising',
      year: '2013',
      technics: ['Cinema 4D', 'After Effects'],
      aspectRatio: '16/9',
      link: 'https://www.youtube.com/watch?v=8R_hPwSHPyM',
      preview: 'images/3d/svetobjevu/svetobjevu1_s.jpg',
      imgs: [
        'images/3d/svetobjevu/svetobjevu1.jpg',
        'images/3d/svetobjevu/svetobjevu2.jpg',
        'images/3d/svetobjevu/svetobjevu3.jpg',
        'images/3d/svetobjevu/svetobjevu4.jpg',
        'images/3d/svetobjevu/svetobjevu5.jpg',
        'images/3d/svetobjevu/svetobjevu6.jpg',
        'images/3d/svetobjevu/svetobjevu7.jpg',
      ],
      intro:
        "An advertising spot for the magazine World of Discoveries. Here we were given a pdf of all the magazine's pages, and it was up to us to animate them and add interesting elements.",
      texts: [''],
    },
  ],
  interests: [
    {
      name: 'Smurf',
      type: 'LEGO',
      year: '2026',
      technics: ['BrickLink Studio'],
      aspectRatio: '1/1',
      link: '',
      preview: 'images/interests/lego/smoula.webp',
      imgs: [
        'images/interests/lego/smoula.webp',
        'images/interests/lego/medievil_house.webp',
      ],
      intro: 'Creations from LEGA',
      texts: ['Model of Smurf, bricks: 1734', 'Medievil House, bricks: 364'],
    },
    {
      name: 'Fantasy tower',
      type: 'sculpting',
      year: '2026',
      technics: ['sculpting'],
      aspectRatio: '3/4',
      link: '',
      preview: 'images/interests/tower/towerpreview.jpg',
      imgs: ['images/interests/tower/tower.jpg'],
      intro: 'Sculpting miniature of tower from concrete.',
      texts: ['Miniature of fantasy tower'],
    },
    {
      name: 'Coloring minifigures',
      type: 'coloring',
      year: '2022-dnes',
      technics: ['coloring'],
      aspectRatio: '16/9',
      link: '',
      preview: 'images/interests/minifigures/minifigures1_m.jpg',
      imgs: [
        'images/interests/minifigures/minifigures1.jpg',
        'images/interests/minifigures/minifigures2.jpg',
        'images/interests/minifigures/minifigures3.jpg',
      ],
      intro: 'Coloring of minifigures from dashboard games.',
      texts: ['Fallout', 'Fallout - New California', 'Witcher'],
    },
    {
      name: 'MPR II',
      type: 'model',
      year: '2015-dnes',
      technics: ['vystřihovánky'],
      aspectRatio: '16/9',
      link: '',
      preview: 'images/interests/mpr/mpr1_m.jpg',
      imgs: ['images/interests/mpr/mpr1.jpg'],
      intro: 'Skoro hotový model Městské památkové rezervace z ABC.',
      texts: [],
    },
    {
      name: 'Design of cards',
      type: 'Design',
      year: '2020-?',
      technics: ['Adobe Illustrator'],
      aspectRatio: '16/9',
      link: '',
      preview: 'images/interests/dashboard/dashboard1_m.jpg',
      imgs: [
        'images/interests/dashboard/dashboard1.jpg',
        'images/interests/dashboard/dashboard2.jpg',
        'images/interests/dashboard/dashboard3.jpg',
      ],
      intro: 'Personal project, where I was creating dashboard game.',
      texts: [
        <>
          Here are a few cards and other suggestions. The illustrations on the
          cards are only provisional. Illustration on the right on the character
          cards: Michal Sirotek.
        </>,
        'And here is the first version of the game that was only in the hand.',
      ],
    },
    {
      name: 'Model of house',
      type: '3D',
      preview: 'images/3d/dum.png',
      imgs: ['images/3d/dum.png'],
      year: '2014',
      link: '',
      technics: ['Cinema 4D'],
      aspectRatio: '304/215',
      intro: 'Visuailsation of house with interior.',
      texts: [],
    },

    {
      preview: 'images/3d/kytara_s.jpg',
      imgs: ['images/3d/kytara_m.jpg'],
      name: 'Guitar',
      type: '',
      year: '2009',
      link: '',
      technics: ['Cinema 4D'],
      aspectRatio: '16/9',
      intro: '',
      texts: [],
    },
    {
      preview: 'images/3d/veteran1_s.jpg',
      imgs: ['images/3d/veteran1_m.jpg'],
      name: 'Veteran',
      type: '',
      year: '2009',
      link: '',
      technics: ['Cinema 4D'],
      aspectRatio: '16/9',
      intro: '',
      texts: [],
    },
  ],
  cv: {
    title: 'CV',
    education: 'Education',
    schools: [
      {
        title: 'Václav Hollar Higher Vocational School',
        subtitle: 'Certified Specialist (DiS), Interactive Graphics',
        years: '2006 - 2009',
      },
      {
        title: 'Czech Technical University in Prague',
        subtitle: 'Faculty of Civil Engineering',
        years: '2005 - 2006',
      },
      {
        title: 'Gymnázium Nad Štolou',
        subtitle: '',
        years: '1997 - 2005',
      },
    ],
    jobs: 'Work Experience',
    companies: [
      {
        title: 'Own projects, self development',
        logo: '',
        subtitle: 'Front-end Developer',
        description:
          'After a while, I had more free time, so I set out to learn some new things and work on own projects. I started taking Next.js courses and also began using Tailwind for CSS and deploying on Vercel.',
        years: 'February 2026 - now',
      },
      {
        title: 'Radio Free Europe/Radio Liberty',
        logo: 'images/logos/rfeorange.png',
        subtitle: 'Graphic Designer, Data Visualization Designer',
        description:
          'Development of interactive projects and microsites. Together with a colleague, I co-founded a new team within Pangea(building a CMS for RFE), dedicated to creating infographics and microsites. Initially, the work focused on developing responsive solutions for visually complex animations and data visualizations. As the team grew, we gradually transitioned to React, TypeScript, and GitHub. I also adapted to a new workflow, moving from online collaboration to a GitFlow-based process due to COVID-19.',
        years: 'October 2014 – January 2026',
      },
      {
        title: 'newslab.cz',
        logo: 'images/logos/newslab.jpg',
        subtitle: 'Graphic Designer',
        description:
          'Creation of visual design and animations for news and journalism projects. Collaboration on interactive projects - originally in Adobe Flash, gradual transition to HTML5. Animation in Cinema 4D and After Effects.',
        years: 'October 2010 – September 2014',
      },
      {
        title: 'PPF Media',
        logo: 'images/logos/futuroom.jpg',
        subtitle: 'Graphic Designer',
        description:
          'Work as part of a team creating interactive animated projects in Adobe Flash. I was responsible for animations using Cinema 4D and After Effects. The projects focused mainly on news coverage and current affairs.',
        years: 'October 2009 – September 2010',
      },
      {
        title: 'Charles University, First Faculty of Medicine',
        logo: 'images/logos/cu.jpg',
        subtitle: 'Graphic Designer',
        description:
          'Creating interactive animations for teaching medical students, created mainly in Adobe Flash. I was involved in the entire process - from concept and design to programming of the interactive parts.',
        years: '2007 - 2009',
      },
    ],
  },
}

export default texts
